const menu =[
  {
    id:1,
    name:'Tasty Burger',
    img:"images/s-img-1.jpg",
    icon:'images/s-1.png',
    description:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda inventore neque amet ipsa tenetur voluptates aperiam tempore libero labore aut."
},
{
  id:2,
  name:'Tasty Pizza',
  img:"images/s-img-2.jpg",
  icon:'images/s-2.png',
  description:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda inventore neque amet ipsa tenetur voluptates aperiam tempore libero labore aut."
},
{
  id:3,
  name:'Cold Ic Cream',
  img:"images/s-img-3.jpg",
  icon:'images/s-3.png',
  description:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda inventore neque amet ipsa tenetur voluptates aperiam tempore libero labore aut."
},
{
  id:4,
  name:'Cold Drinks',
  img:"images/s-img-4.jpg",
  icon:'images/s-4.png',
  description:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda inventore neque amet ipsa tenetur voluptates aperiam tempore libero labore aut."
},
{
  id:5,
  name:'Tasty Sweets',
  img:"images/s-img-5.jpg",
  icon:'images/s-1.png',
  description:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda inventore neque amet ipsa tenetur voluptates aperiam tempore libero labore aut."
},
{
  id:6,
  name:'Healty breakfast',
  img:"images/s-img-6.jpg",
  icon:'images/s-6.png',
  description:"Lorem ipsum dolor sit amet consectetur adipisicing elit. Assumenda inventore neque amet ipsa tenetur voluptates aperiam tempore libero labore aut."
},


]



export default menu;